import * as React from 'react'
import { TaskSizeDropdownConnected } from './TaskSizeDropdownConnected'
import { Provider } from 'react-redux'
import { mockState, createMockStore, MOCK_TASK_A_ID } from 'mockState'

export const TaskSizeDropdownExamples = () => {
  return (
    <div className="TaskSizeDropdownExamples exampleContainer">
      <h1 className="exampleHeader">default</h1>

      <Provider store={createMockStore(mockState)}>
        <TaskSizeDropdownConnected taskId={MOCK_TASK_A_ID} />
      </Provider>
    </div>
  )
}
